/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Webhook_TokenInputs */

const cs_field_webhook_token = /** @type {(inputs: Field_Webhook_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webhook token`)
};

const en_field_webhook_token = /** @type {(inputs: Field_Webhook_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webhook token`)
};

/**
* | output |
* | --- |
* | "Webhook token" |
*
* @param {Field_Webhook_TokenInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_webhook_token = /** @type {((inputs?: Field_Webhook_TokenInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Webhook_TokenInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_webhook_token(inputs)
	return cs_field_webhook_token(inputs)
});